import { BehaviorSubject } from 'bog-arcade-core-ui/observer/BehaviorSubject';
import { GAME_APPLICATION_TYPE_STATE } from '../../stateManagment';
import { GameApplicationType } from '../../core/enums';

const min = 0;
const max = 100;

const landscapeLoadingStage = (function* () {
  yield min;
  yield 7;
  yield 15;
  yield 22;
  yield 30;
  yield 35;
  yield 42;
  yield 50;
  yield 55;
  yield 64;
  yield 82;
  yield 90;
  yield max;
})();

const webLoadingStage = (function* () {
  yield min;
  yield 7;
  yield 15;
  yield 22;
  yield 30;
  yield 35;
  yield 42;
  yield 55;
  yield 82;
  yield 90;
  yield max;
})();

const mobileLoadingStage = (function* () {
  yield min;
  yield 7;
  yield 15;
  yield 22;
  yield 30;
  yield 35;
  yield 42;
  yield 55;
  yield 82;
  yield 90;
  yield max;
})();

const loadingStageByApplicationType = {
  [GameApplicationType.web]: webLoadingStage,
  [GameApplicationType.landscape]: landscapeLoadingStage,
  [GameApplicationType.mobile]: mobileLoadingStage,
};

const loadingStage = loadingStageByApplicationType[GAME_APPLICATION_TYPE_STATE.getValue()];
const initialValue = loadingStage.next().value;

class LoadingStageService {
  stage = new BehaviorSubject(initialValue);
  max = max;
  min = min;
  next = () => {
    const { value, done } = loadingStage.next();
    if (done) {
      const stage = this.stage.getValue();
      if (stage !== max) {
        this.stage.next(value);
      }
      return;
    }
    this.stage.next(value);
  };
}

export const loadingStageService = new LoadingStageService();
